<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="searchTypeOptions"
              :selected="frame0.selectData.COD_NOTICOBJ_SRCH_DIV"
              codeId="COD_NOTICOBJ_SRCH_DIV"
              :defaultOption="'all'"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="searchText"
              v-model="frame0.searchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup="onKeyUpInput($event,'searchText')"
              @keyup.enter="searchAnnouncements"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="dp"
              v-model="frame0.periodDT"
              @confirm="onChangedPeriodDT"
            />
          </div>
        </div>
        <div
          v-if="isCategoryGroupExist"
          class="row"
        >
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-select-box
              v-model="categoryItemSelected"
              placeholder="selectbox"
              :value="{ label: this.$t('MSG_TXT_ALL'), key: '' }"
              :option-list="categoryOptions"
              @list-click="itemSelected"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Reset"
            @click="reset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="searchAnnouncements"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :initialPagesize="10"
        :columns="gridColumns0"
        :dataset="'dataset0'"
      />
      <div
        class="btn_moreView"
        @click="onClickMore"
      >
        <p :class="paging.totalCount === 0 || paging.count === paging.totalCount ? 'disabled' : ''">
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="registerPopup"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['firstRegistrationDTM'];
export default {
  name: 'PGE_CLB_00001', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      bbsId: '',
      bbsName: '',
      isCategoryGroupExist: true,
      approveUseYn: '',
      attachRestrictSize: '',
      tbabRestrictSize: '',
      strUgrnYn: this.$t('MSG_TXT_UGRN'),
      strAnnmYn: this.$t('MSG_TXT_ANNM'),
      categoryOptions: [],
      categoryItemSelected: { label: this.$t('MSG_TXT_ALL'), key: '' },
      frame0: {
        selectData: {
          COD_NOTICOBJ_SRCH_DIV: { key: '', label: '' },
        },
        periodDT: {
        },
        searchText: '',
      },
      startDate: '',
      endDate: '',
      showDetailPopup: false,
      isPaging: false,
      paging: {
        pagePerCount: 5000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    showMoreCount() {
      return `(${this.paging.count}/${this.paging.totalCount})`;
    },
  },
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'rowNumber',
      type: 'string',
      map: 'rowNumber',
    }, {
      name: 'bbsCategoryItemNm',
      type: 'string',
      map: 'bbsCategoryItemNm',
    }, {
      name: 'annNoticeObjTitle',
      type: 'object',
      map: 'annNoticeObjTitle',
    }, {
      name: 'attchDocId',
      type: 'object',
      map: 'attchDocId',
    }, {
      name: 'registrantName',
      type: 'string',
      map: 'registrantName',
    }, {
      name: 'firstRegistrationUserId',
      type: 'string',
      map: 'firstRegistrationUserId',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }, {
      name: 'annNoticeObjSearchedCount',
      type: 'string',
      map: 'annNoticeObjSearchedCount',
    }, {
      name: 'postUID',
      type: 'string',
      map: 'postUID',
    }, {
      name: 'newYN',
      type: 'string',
      map: 'newYN',
    }, {
      name: 'atthDocId',
      type: 'object',
      map: 'atthDocId',
    }, {
      name: 'urgnYN',
      type: 'string',
      map: 'urgnYN',
    },
    {
      name: 'annYN',
      type: 'string',
      map: 'annYN',
    }, {
      name: 'displayLanguageId',
      type: 'string',
      map: 'displayLanguageId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'loginId',
      type: 'string',
      map: 'loginId',
    }, {
      name: 'userName',
      type: 'string',
      map: 'userName',
    }, {
      name: 'userGlobalName',
      type: 'string',
      map: 'userGlobalName',
    }, {
      name: 'departmentName',
      type: 'string',
      map: 'departmentName',
    }, {
      name: 'departmentEnglishName',
      type: 'string',
      map: 'departmentEnglishName',
    }],
  }],
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [{
      text: this.$t('MSG_TXT_SN'),
      datafield: 'rowNumber',
      width: 60,
    }, {
      text: this.$t('MSG_TXT_CATG'),
      datafield: 'bbsCategoryItemNm',
      width: 150,
    },
    {
      text: this.$t('MSG_TXT_ATTH_FILE_YN'),
      datafield: 'atthDocId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
          useSurfixIcon: false,
          handler: this.onClickGrid,
          type: 'link',
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: 50,
    },
    {
      text: this.$t('MSG_TXT_TITLE'),
      datafield: 'annNoticeObjTitle',

      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
          useSurfixIcon: false,
          handler: this.onClickGrid,
          type: 'link',
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    },
    {
      text: this.$t('MSG_TXT_RGST_USR'),
      datafield: 'firstRegistrationUserId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1', // "1", "2" - default: "1"
          type: 'link', // 'link', 'sublink' - default: "link"
          datafieldMap: {
            userId: 'firstRegistrationUserId',
            userName: 'userName',
            userGlobalName: 'userGlobalName',
            departmentName: 'departmentName',
            departmentEnglishName: 'departmentEnglishName',
            displayLanguageId: 'displayLanguageId',
            loginId: 'loginId',
          },
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: 200,
    }, {
      text: this.$t('MSG_TXT_RGST_DTM'),
      datafield: 'firstRegistrationDTM',
      width: 150,
    }, {
      text: this.$t('MSG_TXT_VIEW_CNT'),
      datafield: 'annNoticeObjSearchedCount',
      width: 100,
      cellsalign: 'right',
    }];
  },
  mounted() {
    this.getBBName();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getBBName() {
      this.bbsId = utils.getParameter(this, 'bbsId');
      if (this.bbsId) {
        http.request(this.contextPageId, 'DTS_CLB_00044', {
          path: {
            'bulletin-board-id': this.bbsId,
          },
        }).then(res => {
          this.bbsName = res.data[0].bbsName;
          this.approveUseYn = res.data[0].approveUseYn;
          this.attachRestrictSize = res.data[0].attachRestrictSize;
          this.tbabRestrictSize = res.data[0].tbabRestrictSize;
          if (!utils.isEmpty(res.data[0].bbsCatgGrpId)) {
            this.isCategoryGroupExist = true;
            this.categoryItems();
          } else {
            this.isCategoryGroupExist = false;
          }
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_BBS_NO_AUTH_PATH'), null, null);
      }
    },
    onChangedPeriodDT() {
      this.startDate = `${utils.toStringByFormat(this.frame0.periodDT.from, 'YYYYMMDD')}000000`;
      this.endDate = `${utils.toStringByFormat(this.frame0.periodDT.to, 'YYYYMMDD')}235959`;
    },
    itemSelected(e) {
      this.categoryItemSelected = e;
    },
    categoryItems() {
      const pathParam = {
        'bulletin-board-id': this.bbsId,
      };
      http.request(this.contextPageId, 'DTS_CLB_00050', {
        path: pathParam,
      }).then(res => {
        if (res.data) {
          const optionList = res.data;
          let i;
          for (i = 0; i < optionList.length; i++) {
            optionList[i].label = optionList[i].bbsCatgItemNm;
            optionList[i].key = optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemNm;
            this.categoryOptions = optionList;
          }
          this.categoryOptions.unshift({ key: '', label: this.$t('MSG_TXT_ALL') });
        }
      });
    },
    reset() {
      utils.forEach(this.frame0, (value, key) => {
        switch (key) {
          case 'selectData':
            this.$refs.searchTypeOptions.reset();
            break;
          default:
            this.frame0[key] = '';
            this.categoryItemSelected = { label: this.$t('MSG_TXT_ALL'), key: '' };
            this.frame0.periodDT = { from: '', to: '' };
            this.startDate = '';
            this.endDate = '';
            break;
        }
      });
    },
    onClickValidate() {
      if (!this.$refs.dp.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
    searchAnnouncements() {
      if (this.onClickValidate()) return false;
      if (!this.bbsId) {
        utils.messageBox('warning', this.$t('MSG_ALT_BBS_NO_AUTH_PATH'), null, null);
        return false;
      }
      this.paging.currentPage = 1;
      this.paging.totalCount = 0;
      this.paging.count = 0;
      this.dataset0.setRawData([], { preventBackup: true });
      this.searchApi();
    },
    searchApi() {
      let title;
      let registrant;
      const searchCond = this.frame0.selectData.COD_NOTICOBJ_SRCH_DIV.key;
      if (searchCond === 'ALL') {
        registrant = this.frame0.searchText;
        title = this.frame0.searchText;
      } else if (searchCond === 'T') {
        registrant = '';
        title = this.frame0.searchText;
      } else {
        registrant = this.frame0.searchText;
        title = '';
      }
      const queryParams = {
        announcementSearchCond: searchCond,
        announcementTitle: title,
        announcementRegistUsr: registrant,
        registStartDt: this.startDate,
        registEndDt: this.endDate,
        boardCategoryItemId: this.isCategoryGroupExist ? this.categoryItemSelected.key : null,
        bbsId: this.bbsId,
        currentPage: this.paging.currentPage,
        pagePerCount: this.paging.pagePerCount,
      };
      http.request(this.contextPageId, 'DTS_CLB_00001', {
        query: queryParams,
      }).then(res => {
        if (res.data.length > 0) {
          this.paging.totalCount = res.data[0].totalCount;
        }
        utils.dateformatToClientInArray(res.data, dateTypeFields);
        res.data.forEach(element => {
          const tmpUgrnYn = element.urgnYN === 'Y' ? `[${this.strUgrnYn}]` : '';
          const tmpAnnmYn = element.annYN === 'Y' ? `[${this.strAnnmYn}]` : '';
          const shownew = element.newYN !== 'N';
          const showAttachment = !!element.atthDocId;
          const annNoticeObjTitle = { text: tmpUgrnYn + tmpAnnmYn + element.annNoticeObjTitle, showattach: false, shownew };
          element.annNoticeObjTitle = annNoticeObjTitle;
          element.atthDocId = { text: '', showattach: showAttachment, shownew: false };
        });

        res.data = utils.getFilteredDataFromDataset(res.data, this.dataset0, true);
        const { data } = this.dataset0;
        const newData = [];
        utils.forEach(data, row => newData.push(row));
        utils.forEach(res.data, row => newData.push(row));
        this.dataset0.setRawData(newData, { preventBackup: true });
        this.paging.count = this.dataset0.data.length;

        if (!utils.isUndefined(res.data) && this.paging.count < this.paging.totalCount) {
          this.isPaging = true;
        } else {
          this.isPaging = false;
        }
      });
    },
    onClickGrid(btn, dataRow) {
      this.detailPopup(dataRow.postUID);
    },
    detailPopup(postUID) {
      if (postUID) {
        this.updateView(postUID);
      }
      utils.openLayerPopup('PGE_CLB_00002', this.onRequestInfoCallback, {
        size: 'xlg',
        pageInitialData: {
          postIdParam: postUID,
          bbsName: this.bbsName,
          bbsId: this.bbsId,
          pageId: this.contextPageId,
          bbsTypeCode: 'N',
          isCategoryGroupExist: this.isCategoryGroupExist,
          approveUseYn: this.approveUseYn,
          attachRestrictSize: this.attachRestrictSize,
          tbabRestrictSize: this.tbabRestrictSize,
        },
      });
    },
    registerPopup() {
      if (!this.bbsId) {
        utils.messageBox('warning', this.$t('MSG_ALT_BBS_NO_AUTH_PATH'), null, null);
      } else {
        utils.openLayerPopup('PGE_CLB_00011', null, {
          size: 'xlg',
          pageInitialData: {
            bbsName: this.bbsName,
            bbsId: this.bbsId,
            isCategoryGroupExist: this.isCategoryGroupExist,
            approveUseYn: this.approveUseYn,
            attachRestrictSize: this.attachRestrictSize,
            tbabRestrictSize: this.tbabRestrictSize,
            pageId: this.contextPageId,
          },
        });
      }
    },
    onKeyUpInput(event, name) {
      const searchFieldNewText = this.frame0[name];
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.frame0[name] = this[name];
          this.$refs[name].setFocus();
        });
      } else {
        this[name] = searchFieldNewText;
      }
    },
    onRequestInfoCallback(value) {
      if (value) {
        this.searchAnnouncements();
      }
    },
    updateView(postUID) {
      const pathParam = {
        'post-id': postUID,
      };
      const queryParams = {
        bbsId: this.bbsName,
        bbsLogTypeCode: 'R',
        userId: this.$store.getters.userInfo.userName,
        deptID: 'TEST',
      };
      http.request(this.contextPageId, 'DTS_CLB_00006', {
        path: pathParam,
        query: queryParams,
      }).then(res => {
        if (res.data.resultCode === '1') {
          this.searchAnnouncements();
        }
      });
    },
    onClickMore() {
      if (this.isPaging) {
        this.paging.currentPage += 1;
        this.searchApi();
      }
    },
  },
};
</script>
<style scoped>
</style>
